import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { getLeafChildrenData } from 'timeSheet/utils';
import { TotalTimeRenderer } from 'timeSheet/components/CellRenderers';

const useTotalColumn = ({
  updateStartTime,
  updateEndTime,
  hasActionPermission,
  updateOSStartTime,
  updateOSEndTime,
  allowUpdateExternal = false
}) => {
  const { t } = useContext(ConfigContext);

  const comparator = useCallback((valueA, valueB) => valueA - valueB, []);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) {
        const groupItems = getLeafChildrenData(params.node);
        return TotalTimeRenderer({
          rowData: {
            actualTotal: groupItems.reduce((sum, item) => sum + (item.actualTotal || 0), 0),
            subRows: groupItems,
            summarized: false
          },
          columnData: {
            updateStartTime,
            updateEndTime,
            updateOSStartTime: allowUpdateExternal ? updateOSStartTime : undefined,
            updateOSEndTime: allowUpdateExternal ? updateOSEndTime : undefined,
            readOnly: !hasActionPermission
          }
        });
      }

      return TotalTimeRenderer({
        rowData: params.data,
        columnData: {
          updateStartTime,
          updateEndTime,
          updateOSStartTime: allowUpdateExternal ? updateOSStartTime : undefined,
          updateOSEndTime: allowUpdateExternal ? updateOSEndTime : undefined,
          readOnly: !hasActionPermission
        }
      });
    },
    [updateStartTime, updateEndTime, updateOSStartTime, updateOSEndTime, hasActionPermission, allowUpdateExternal]
  );

  return useMemo(
    () => ({
      field: 'actualTotal',
      headerName: t('totalTime'),
      width: 90,
      minWidth: 90,
      sortable: true,
      comparator,
      cellClass: 'justify-start',
      cellRenderer
    }),
    [t, comparator, cellRenderer]
  );
};

export default useTotalColumn;
